/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';

/**
 * Global configuration
 */
@Injectable({
  providedIn: 'root',
})
export class IVCSApiConfiguration {
  rootUrl: string = '';
}

/**
 * Parameters for `IVCSModule.forRoot()`
 */
export interface IVCSApiConfigurationParams {
  rootUrl?: string;
}
